import { useEffect, useState } from 'react';
import { navLinks } from '../content';

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#FBF9F4]/90 backdrop-blur-md border-b border-black/5' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-[72px] max-w-[1200px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="group flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-600 text-white transition-colors group-hover:bg-emerald-700">
            <span className="font-display text-lg font-bold leading-none">瓜</span>
          </span>
          <span className="flex flex-col leading-none">
            <span className="text-[17px] font-bold tracking-tight text-stone-900">吃瓜软件</span>
            <span className="mt-0.5 text-[10px] tracking-[0.3em] text-stone-500">官网使用指南</span>
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap text-sm text-stone-600 transition-colors hover:text-emerald-700"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#guides"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-emerald-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-emerald-700 sm:inline-flex"
          >
            开始阅读
            <i className="ri-arrow-right-line text-base"></i>
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-md text-stone-700 transition-colors hover:bg-black/5 md:hidden"
            aria-label="打开菜单"
          >
            <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-black/5 bg-[#FBF9F4] px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-stone-700 transition-colors hover:bg-emerald-50"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#guides"
              onClick={() => setMenuOpen(false)}
              className="mt-1 rounded-md bg-emerald-600 px-3 py-2.5 text-center text-sm font-medium text-white"
            >
              开始阅读
            </a>
          </div>
        </div>
      )}
    </header>
  );
}